define('SelectView',['underscore', 'jquery', 'backbone', 'app', 'bootstrapSelect'],
    function (_, $, Backbone, app) {

    var SelectView = Backbone.View.extend({
        initialize: function(){
            this.reset();
            this.$el.data('view',this);
        },
        remove:function(){
            Backbone.View.prototype.remove.apply(this);
        },
        reset:function(){
            var view = this,
                options = _(view.$el.data()).extend({
                style: 'select-basic',
                noneSelectedText: app.t('Aucune sélection','UI')
                });
            var selectpicker = view.selectpicker = view.$el.selectpicker(options);
            //
            selectpicker.on('change',function(e){
                view.trigger('change',e,e.currentTarget.value);
            });
        },
        spexec:function(func){
            // Select Picker exec shortcut
            this.$el.selectpicker(func);
        },
        val : function(v){
            if(!_.isUndefined(v)){
                this.$el.selectpicker('val',v);
            }
            return this.$el.selectpicker('val');
        },
        refreshSelect : function(){
            this.spexec('refresh');
        },
        destroySelect : function(){
            this.spexec('destroy');
        },
        hide : function(){
            this.spexec('hide');
        },
        show : function(){
            this.spexec('show');
        },
        focus : function(){
            this.spexec('focus');
        }
    });

    SelectView.initializeSelectsOfView = function(view){
        var views = [];
        view.$('.selectpicker').each(function(){
            if(!$(this).data('view')) views.push(new SelectView({el:this}));
        });
        return views;
    };
    
    return SelectView;

});
